import React from "react";
import PropTypes from "prop-types";
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';

class Dialog extends React.Component {

    constructor(props) {
        super(props);
        this.dialog = null;
        this.defaultSettings = {
            closableByDimmer: true,
            movable: false,
            transition: 'slide'
        }
    }

    componentDidMount() {
        const {title, description, labelOK, labelCancel, onOK} = this.props;
        let settings = {
            ...this.defaultSettings,
            title: title,
            message: description,
            labels: {
                ok: labelOK ? labelOK : "OK",
                cancel: labelCancel ? labelCancel : "Cancel"
            }
        };

        if (onOK) {
            settings = {
                ...settings,
                onok: () => {
                    onOK();
                }
            };
        }

        this.dialog = alertify.confirm().setting(settings).show();
    }

    render() {
        return null;
    }
}

Dialog.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    labelOK: PropTypes.string,
    labelCancel: PropTypes.string,
    onOK: PropTypes.func
};

export default Dialog;


// WEBPACK FOOTER //
// ./src/components/Dialog.js